import i18n from '@/i18n.js';

const parseModelIdentifier = (value) => {
    const raw = String(value ?? "").trim().toUpperCase();
    const digits = raw.replace(/\D/g, "").replace(/^0+/, "");

    return {
        raw,
        digits
    };
};

const parseModelList = (value) => {
    return String(value ?? "")
        .split(",")
        .map(modelCode => modelCode.trim())
        .filter(Boolean);
};

const resolveModelosSinStock = (state) => {
    const fromState = Array.isArray(state.modelosSinStock)
        ? state.modelosSinStock.filter(Boolean)
        : [];

    if (fromState.length > 0) {
        return fromState;
    }

    return parseModelList(process.env.VUE_APP_MODELOS_SIN_STOCK);
};

export default {
    isDisableCustomPrices: () => process.env.VUE_APP_DISABLE_CUSTOM_PRICE === 'true',
    comercialLoginAvalible() {
        if (typeof process.env.VUE_APP_COMERCIAL_LOGIN === "boolean") {
            return process.env.VUE_APP_COMERCIAL_LOGIN;
        }

        if (typeof process.env.VUE_APP_COMERCIAL_LOGIN === "string") {
            return process.env.VUE_APP_COMERCIAL_LOGIN.toLowerCase() === "true";
        }

        return false;
    },
    clientCartAvalible(state, getters) {
        if (getters.isYouReprocesos) return false;
        if (typeof process.env.VUE_APP_CLIENT_CART === "boolean") {
            return process.env.VUE_APP_CLIENT_CART;
        }

        if (typeof process.env.VUE_APP_CLIENT_CART === "string") {
            return process.env.VUE_APP_CLIENT_CART.toLowerCase() === "true";
        }

        return false;
    },
    isPreciosProveedoresActive: () => process.env.VUE_APP_PRECIOS_PROVEEDORES === 'true',
    defaultPdfConfig: (state, getters, rootState) => {
        let defaultConfig = {
            dialog: false,
            colorSeleccionado: rootState.carrito.carrito.colorCode,
            porcentajeProductos: 0.0,
            porcentajeReprocesos: 0.0,
            costeExtra: 0.0,
            Observaciones: "",
            Empresa: "",
            correoContacto: "",
            telefono: "",
            calle: "",
            cp: "",
            poblacion: "",
            ciudad: "",
            pais: "",
            customImg: null,
            logo: (rootState.modelo.modelInfo?.originalBrand == "STM" || rootState.modelo.modelInfo?.originalBrand == "STA")
                ? "https://static.gorfactory.es/b2b/Calculadora/logo_stamina.png"
                : "https://static.gorfactory.es/b2b/Calculadora/logo_roly.png"
        };

        if (getters.isYouReprocesos) {
            defaultConfig.Observaciones = state.youReprocesosConfig?.observaciones ?? "";
            defaultConfig.correoContacto = state.youReprocesosConfig?.contactEmail ?? "";
            defaultConfig.telefono = state.youReprocesosConfig?.contactPhone ?? "";

            defaultConfig.calle = state.youReprocesosConfig?.addressStreet ?? "";
            defaultConfig.cp = state.youReprocesosConfig?.addressCp ?? "";
            defaultConfig.poblacion = state.youReprocesosConfig?.addressState ?? "";
            defaultConfig.ciudad = state.youReprocesosConfig?.addressCity ?? "";
            defaultConfig.pais = state.youReprocesosConfig?.addressCountry ?? "";

            defaultConfig.customImg = state.youReprocesosConfig?.logoPdfUrl || state.youReprocesosConfig?.logourl || null;

            defaultConfig.CustomLogo = state.youReprocesosConfig?.logoPdfUrl || state.youReprocesosConfig?.logourl || null;

            defaultConfig.CustomLogoPath = defaultConfig.CustomLogo;
        }

        return defaultConfig

    },
    actualLogo: (state, getter) => {
        return getter.isYouReprocesos
            ? state.youReprocesosConfig?.bannerUrl ? state.youReprocesosConfig?.bannerUrl : state.youReprocesosConfig?.logourl
            : getter.isOk
                //TODO: si se hace un desplegable, cambiar a por el correcto
                ? "https://erolystorage.blob.core.windows.net/oktextil/LOGO_OK_BLANCO.svg"
                : getter.isStamina
                    ? `${process.env.VUE_APP_STATIC_IMG_URL}/images/header/Logo_Stamina_200x56px.svg`
                    : `${process.env.VUE_APP_STATIC_IMG_URL}/images/header/logo_Roly_2025.svg`;
    },
    tamanosImpresionDirecta() {
        return [
            {
                value: 1,
                Ancho: 400,
                Alto: 500,
                text: i18n.t(
                    "configuration.ImpresionDirecta.Size1"
                ),
            },
            {
                value: 2,
                Ancho: 300,
                Alto: 400,
                text: i18n.t(
                    "configuration.ImpresionDirecta.Size2"
                ),
            },
            {
                value: 3,
                Ancho: 250,
                Alto: 250,
                text: i18n.t(
                    "configuration.ImpresionDirecta.Size3"
                ),
            },
            {
                value: 4,
                Ancho: 100,
                Alto: 100,
                text: i18n.t(
                    "configuration.ImpresionDirecta.Size4"
                ),
            },
        ];
    },
    isProveedor: (state) => state.isProveedor && process.env.VUE_APP_PRECIOS_PROVEEDORES === 'true',
    allSizes: (state) => state.allSizes,
    allSizeByTecnica: (state) => (tecnica) => {
        console.log("🚀 ~ file: ConfigGetters.js:111 ~ tecnica:", tecnica)
        const sizesMap = {
            "Serigrafia": ["A3", "A4", "A5", "A6", "A7", "A8"],
            "SerigrafiaTarifaTextil": ["A3", "A4", "A5", "A6", "A7", "A8"],
            "DTF": ["A3", "A4", "A5", "A6", "A7", "A8"],
            "SublimacionParcial": ["A3", "A4", "A5", "A6", "A7", "A8"],
            "TransferTintas": ["A3", "A4", "A5", "A6", "A7", "A8", "A10"]
        };

        const sizes = sizesMap[tecnica] || Object.keys(state.allSizes);

        return sizes.reduce((obj, key) => {
            if (state.allSizes[key]) {
                obj[key] = state.allSizes[key];
            }
            return obj;
        }, {});
    },
    allTintas: (state, getters, rootState, rootGetter) => {
        let tintas = [];

        let allTintas = [
            {
                text: rootGetter["modelo/isReprocesosStm"] && rootGetter["modelo/isStaminaModel"] ? i18n.t("configuration.Tintas.Tintas especiales STM") : i18n.t("configuration.Tintas.Tinta1"),
                value: 1,
            },
            {
                text: i18n.t("configuration.Tintas.Tinta2"),
                value: 2,
            },
            { text: i18n.t("configuration.Tintas.Tinta3"), value: 3 },
            {
                text: i18n.t("configuration.Tintas.Tinta5"),
                value: 5,
            },
            { text: i18n.t("configuration.Tintas.Tinta6"), value: 6 },
        ]

        const isCbModel = rootGetter["modelo/modelInfoFromCatalog"]?.code.startsWith("CB");

        if (isCbModel) {
            tintas = allTintas.filter(t => [6].includes(t.value));
        }
        else if (rootGetter["modelo/isReprocesosStm"] && rootGetter["modelo/isStaminaModel"]) {
            tintas = allTintas.filter(t => [5, 1].includes(t.value));
        }
        else if (!rootGetter["modelo/contieneElastano"]) {
            tintas = allTintas;
        }
        else {
            tintas = allTintas.filter(t => [2,3].includes(t.value));
        }

        let forcedTinta = rootGetter['modelo/forzarTipoTinta']

        if (
            forcedTinta != 5 &&
            forcedTinta != null &&
            forcedTinta > 0
        ) {

            let tinta = tintas.find((t) => t.value == forcedTinta);
            
            if (tinta) {
                tintas = [tinta];
            } else {
                // Cambiamos la tinta 5, por la que esta forzada
                tintas = tintas.map(t => {
                    if (t.value === 5) {
                        return {
                            text: i18n.t("configuration.Tintas.Tinta" + forcedTinta),
                            value: forcedTinta
                        };
                    }
                    return t;
                });

                // Aseguramos que la tinta forzada quede siempre primera
                tintas.sort((a, b) => {
                    if (a.value === forcedTinta && b.value !== forcedTinta) return -1;
                    if (a.value !== forcedTinta && b.value === forcedTinta) return 1;
                    return 0;
                });
            }
        }
        return tintas;
    },
    optionsNumerosDtf: (state) => (numerosDobles = false) => {
        return state.optionsNumerosDtf.filter(option => option.isDobleNumero == numerosDobles);
    },
    optionsNumerosTransfer: (state) => (numerosDobles = false) => {
        return state.optionsNumerosTransfer.filter(
            option => option.isDobleNumero === numerosDobles
        );
    },
    optionsNumbers: (state, getters) => (tecnica, numerosDobles = false) => {
        console.log("🚀 ~ numerosDobles:", numerosDobles)
        console.log("🚀 ~ tecnica:", tecnica, tecnica == "DTFNumeros" || tecnica.valueTecnica == "DTFNumeros")
        if (tecnica == "DTFNumeros" || tecnica.valueTecnica == "DTFNumeros") {
            return getters.optionsNumerosDtf(numerosDobles);
        }
        else if (tecnica == "TransferNumeros" || tecnica.valueTecnica == "TransferNumeros") {
            return getters.optionsNumerosTransfer(numerosDobles);
        }
        else {
            return []
        }
    },
    getMedidasByTamano: (state) => (tamano) => {
        return state.allSizes[tamano ?? "A3"]
    },
    actualLanguage: (state) => {
        return state.locale
    },
    actualLanguageRegion: (state) => {
        if (state.locale == "es")
            return "es-ES";
        else if (state.locale == "en")
            return "en-GB";
        else if (state.locale == "fr")
            return "fr-FR";
        else if (state.locale == "de")
            return "de-DE";
        else if (state.locale == "it")
            return "it-IT";
        else if (state.locale == "pt")
            return "pt-PT";
        else if (state.locale == "ru")
            return "ru-RU";
        else if (state.locale == "fi")
            return "fi-FI";
        else if (state.locale == "ro")
            return "ro-RO";
        else if (state.locale == "nl")
            return "nl-NL";
        else if (state.locale == "pl")
            return "pl-PL";
        else if (state.locale == "gr" || state.locale == "el")
            return "el-GR";
        else if (state.locale == "lv")
            return "lv-LV";
        else if (state.locale == "cz" || state.locale == "cs")
            return "cs-CZ";
        else if (state.locale == "sl" || state.locale == "si")
            return "si-SL";
        else
            return state.locale
    },
    getLocaleFromLanguageRegion: () => (languageRegion) => {
        switch (languageRegion) {
            case "es-ES":
                return "es";
            case "en-GB":
                return "en";
            case "fr-FR":
                return "fr";
            case "de-DE":
                return "de";
            case "it-IT":
                return "it";
            case "pt-PT":
                return "pt";
            case "ru-RU":
                return "ru";
            case "fi-FI":
                return "fi";
            case "ro-RO":
                return "ro";
            case "nl-NL":
                return "nl";
            case "pl-PL":
                return "pl";
            case "el-GR":
                return "gr";
            case "lv-LV":
                return "lv";
            case "cs-CZ":
                return "cz";
            case "si-SL":
                return "sl";
            default:
                return languageRegion;
        }
    },
    tecnicaMapExtraParam: () => {
        return new Map([
            ["Serigrafia", "Serigrafia"],
            ["TransferTintas", "Transfer"],
            ["Impresion", "ImpresionDirecta"],
            ["Manipulacion", "Manipulados"],
            ["SublimacionParcial", "Sublimacion"],
            ["Bordados", "Bordado"],
            ["SerigrafiaEtiquetas", "Etiquetas"],
            ["TransferNumeros", "Números"],
            ["ImpresionVinilo", "ImpresionVinilica"],
            ["SerigrafiaNonWoven", "SerigrafiaNonWoven"],
            ["TransferEspeciales", "TransferEspeciales"],
            ["Digital", "Digital"],
            ["Laser", "Laser"],
            ["Tampografia", "Tampografia"],
            ["Termografia", "Termograbado"],
            ["BordadoStm", "Bordados"],
            ["CuatricomiaStm", "Cuatricomia"],
            ["DTF", "DTF"],
            ["Planchado", "Planchado"],// No existe
            ["Doming", "Doming"],

            // Nuevos roly
            ["SublimacionTotal", "Sublimacion"],
            ["SublimacionTotalMedidas", "Sublimacion"],
            ["TransferEtiquetas", "Etiquetas"],
            ["TransferNumeroDigitos", "Números"],

            // Nuevos stamina
            ["SerigrafiaStm", "Serigrafia"],
            ["SerigrafiaStmSombreros", "Serigrafia"],
            ["SublimacionStm", "Sublimacion"],
            ["SublimacionStmSombreros", "Sublimacion"],
            ["SublimacionStmTazas", "Sublimacion"],
            ["TransferDigitalStm", "Transfer"],
            ["TransferStm", "Transfer"],
            ["DtfUv", "DtfUv"],
            ["DtfUvStm", "DtfUv"],
            ["DtfUvMetrosLineales", "DtfUv"],
            ["Dtf3d", "Dtf3d"]
        ]);
    },
    getTecnicaMapExtraParam: (state, getter) => (tecnica) => {
        return getter.tecnicaMapExtraParam.get(tecnica) ?? tecnica;
    },
    translateTecnica: () => function (tecnica) {
        if (!tecnica) return;
        if (tecnica.includes('Sublimacion'))
            return this.$t('tecnicas.SUBLIMACIÓN');
        else if (tecnica.includes('Serigrafia'))
            return this.$t("tecnicas.SERIGRAFÍA");
        else if (tecnica.includes('TransferEspeciales'))
            return this.$t("tecnicas.TRANSFER ESPECIALES");
        else if (tecnica.includes('TransferNumeros'))
            return this.$t("tecnicas.NUMEROS-TRANSFER");
        else if (tecnica.includes('Transfer'))
            return this.$t("tecnicas.TRANSFER");
        else if (tecnica.includes('ImpresionVinilo'))
            return this.$t("tecnicas.IMPRESIÓN VINILO");
        else if (tecnica.includes('ImpresionDirecta') || tecnica.includes('Impresion'))
            return this.$t("tecnicas.IMPRESIÓN DIRECTA");
        else if (tecnica.includes("Bordado"))
            return this.$t("tecnicas.BORDADOS");
        else if (tecnica.includes("TransferNumeros"))
            return this.$t("tecnicas.NÚMEROS");
        else if (tecnica.includes("SerigrafiaNonWoven"))
            return this.$t("tecnicas.BOLSAS NON WOVEN");
        else if (tecnica.includes("Digital"))
            return this.$t("tecnicas.DIGITAL")
        else if (tecnica.includes("Laser"))
            return this.$t("tecnicas.LASER")
        else if (tecnica.includes('DTFNumeros'))
            return this.$t("tecnicas.NUMEROS-DTF");
        else if (tecnica.includes("DtfUv") || tecnica.includes("DTF-UV"))
            return this.$t("tecnicas.DTF-UV");
        else if (tecnica.includes("Dtf3d") || tecnica.includes("DTF-3D"))
            return this.$t("tecnicas.DTF-3D");
        else if (tecnica.includes("DTF"))
            return this.$t("tecnicas.TRANSFER DIGITAL (DTF)");
        else if (tecnica.includes("Tampografia"))
            return this.$t("tecnicas.TAMPOGRAFÍA")
        else if (tecnica.includes("Termografia"))
            return this.$t("tecnicas.TERMOGRABADO");
        else if (tecnica.includes("DomingStm"))
            return this.$t("tecnicas.DOMING");
        else if (tecnica.includes("CuatricomiaStm"))
            return this.$t("tecnicas.CUATRICOMIA");
        else if (tecnica.includes("Planchado"))
            return this.$t("tecnicas.PLANCHADO");
        else if (tecnica.includes("Manipulados") || tecnica.includes("Manipulacion"))
            return this.$t("tecnicas.MANIPULADOS");
        else if (tecnica.includes("TRANSFER DIGITAL METROS LINEALES")) 
            return this.$t("tecnicas.TRANSFER DIGITAL METROS LINEALES")
        else
            return "";

    },
    comercialInfo: (state) => state.comercial,
    comercialToken: (state) => state.comercial?.authToken,
    userList: (state) => {
        if (!state.userList) return [];
        return Object.values(state.userList).sort((a, b) => (b._order || 0) - (a._order || 0));
    },
    loggedClient: (state) => state.loggedClient,
    userOfClient: (state) => state.userOfClient,
    key: (state) => state.key,
    resetCalculadora: (state) => state.resetCalculadora,
    isModeIntranetActive: (state, getters) => getters.comercialLoginAvalible && getters.comercialToken && getters.comercialToken != "",
    colorSelected: (state, getter, rootState, rootGetter) => {
        
        if (state.colorSelected && (!rootGetter['carrito/sortColorAvalibleAndWithQuantity'].length || rootGetter['carrito/sortColorAvalibleAndWithQuantity'].some(c => c.code == state.colorSelected))) return state.colorSelected;
        return rootGetter['carrito/sortColorAvalibleAndWithQuantity'][0]?.code;
    },
    // state.colorSelected,

    activeComercial: (state, getters) => getters.loggedClient && getters.userOfClient && getters.comercialToken,
    activeClient: (state, getters) => !getters.activeComercial && getters.clientCartAvalible,
    isYouReprocesos: state => state.youReprocesosId != null,
    youReprocesosConfig: state => state.youReprocesosConfig,
    youReprocesosSession: state => state.youReprocesosSession,
    extraPrice: state => state.youReprocesosConfig?.extraPrice ?? 0,
    shippingCost: state => state.youReprocesosConfig?.shippingPrice ?? 0,
    company: state => state.company,
    isOk: state => state.company == "OKTXT",
    isStamina: state => state.originalBrand == "STA",
    initLoaderYouReprocesos: state => state.initLoaderYouReprocesos ?? false,
    sizeDigitalOptions: state => state.sizeDigitalOptions,
    activeBorradores: () => process.env.VUE_APP_ACTIVE_BORRADORES == 'true',
    catalogColors: state => state.catalogColors,
    catalogSizes: state => state.catalogSizes,
    modelosSinStock: state => resolveModelosSinStock(state),
    ignoreStockByModel: (state, getters) => modelCode => {
        const target = parseModelIdentifier(modelCode);

        if (!target.raw) return false;

        return getters.modelosSinStock.some(item => {
            const candidate = parseModelIdentifier(item);

            const rawMatch = target.raw && candidate.raw && target.raw === candidate.raw;
            const digitsMatch = target.digits && candidate.digits && target.digits === candidate.digits;

            return rawMatch || digitsMatch;
        });
    },
    sublimacionTecnicas: state => state.sublimacionTecnicas,
    saving3dDesign: state => state.saving3dDesign > 0
}